import React, { createContext, useState, useEffect } from 'react';
import XLSX from 'xlsx';
import { useFormik } from 'formik';
import * as Yup from "yup";
import moment from 'moment';
import _ from 'lodash';
import { Card, Form, Jumbotron, Col, Button } from 'react-bootstrap';
import FormControls from '../../controls/formControls';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { CustomerAccountService } from '../../services';
import { LinkContainer } from 'react-router-bootstrap';

const monthPrevious = (last = false) => {
    var d = new Date();
    d.setDate(0);
    if (!last) {
        d.setDate(1);
    }
    return d;
}

const CustomerCodingEventReport = (props) => {
    const [metrics, setMetrics] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [initFromDate, setInitFromDate] = useState(null);
    const [initToDate, setInitToDate] = useState(null);
    useEffect(() => {
        //const initFromDate = monthPrevious().toISOString().split('T')[0];
        //const initToDate = monthPrevious(true).toISOString().split('T')[0];
        const initFromDate = moment(new Date()).subtract(1, 'months').startOf('month').toISOString().split('T')[0];
        const initToDate = moment(new Date()).startOf('month').subtract(1, 'days').toISOString().split('T')[0]; // .subtract(1, 'months').endOf('month').subtract(1, 'days')
        setInitFromDate(initFromDate);
        setInitToDate(initToDate);
        getCustomerList();
    }, [])


    const assessmentMetricsValidationSchema = {
        selectedAccounts: Yup.array().min(1, 'You must select at least one account'),
        dateFrom: Yup.date().nullable().required('You must select a from date'),
        dateTo: Yup.date().nullable().required('You must select an end date').min(
            Yup.ref('dateFrom'), 'End date cannot be before start date.'
        )
    };

    const formik = useFormik({
        initialValues: { selectedAccounts: [], dateFrom: initFromDate, dateTo: initToDate },
        validationSchema: Yup.object().shape(assessmentMetricsValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            //await saveCustomer(values);
            await getMetrics(values);
            setSubmitting(false);
        }
    });

    const getCustomerList = async () => {
        const customerService = new CustomerCodingEventService();
        var results = await customerService.getCustomerRef(false, true);
        if (results.result) {
            let accounts = results.model.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
            let accountList = accounts.map((acc) => (
                {
                    value: acc.id,
                    label: acc.name
                }
            ));

            setCustomers(accountList);
            if (accountList.length === 1) {
                //formik.values.selectedAccounts.push(accountList[0].id);
                formik.setFieldValue('selectedAccounts', [accountList[0].value], true)
            }
        } else {
            alert("Failed to get customer list");
        }

    }

    const getMetrics = async (values) => {
        const { selectedAccounts, dateFrom, dateTo } = values;
        const codingEventService = new CustomerCodingEventService();
        var results = await codingEventService.getCodingEvents(selectedAccounts, dateFrom, dateTo);
        if (results.result) {
            const data = results.model;
            const accounts = Object.keys(data);
            const newResults = accounts.map(account => (
                { accountName: account, data: data[account] }
            ));
            const wb = XLSX.utils.book_new();
            newResults.forEach(acc => {
                const accName = acc.accountName.slice(0, 22)
                let headers = [];
                const keys = Object.keys(acc.data[0]);
                const newData = acc.data.map(d => {
                    let no = {};
                    keys.forEach(k => {
                        no[_.startCase(_.camelCase(k))] = d[k];
                    });
                    return no;
                })
                //Object.keys(acc.data[0]).forEach(key => {
                //    headers.push(_.startCase(_.camelCase(key)))
                //});
                //acc.data[0].forEach(r => {
                //    r = _.startCase(_.camelCase(r))
                //});
                const ws = XLSX.utils.json_to_sheet(newData, { header: headers, range: 0 }); //acc.data
                XLSX.utils.book_append_sheet(wb, ws, accName);
            })
            const wbNameArray = accounts.map(account => account.replaceAll(' ', '').substr(0, 20));
            const wbName = wbNameArray.join('_');

            /* generate XLSX file and send to client */
            XLSX.writeFile(wb, wbName + "_" + dateFrom + "_" + dateTo + ".xlsx")
        } else {
            alert("No results returned.");
        }
    }

    return (
        <Card className="h-80">
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Coding History Report</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                {/*{JSON.stringify(formik.values, null, 2)}<br />*/}
                {/*{JSON.stringify(formik.errors, null, 2)}*/}
                <Jumbotron className="pt-3 pb-2">
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12">
                            <FormControls.Multiselect
                                options={customers}
                                name="selectedAccounts"
                                label="Accounts"
                                formHandler={formik}
                            />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="Start Date"
                                type="date"
                                name="dateFrom"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="End Date"
                                type="date"
                                name="dateTo"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="4" md="12">
                            <Button variant="success" disabled={!formik.dirty || !formik.isValid || formik.isSubmitting} onClick={() => formik.submitForm()}>Run</Button>
                        </Form.Group>
                    </Form.Row>
                </Jumbotron>
            </Card.Body>
        </Card>
    )
}

export default CustomerCodingEventReport;